import { configureStore } from "@reduxjs/toolkit";
import mainReducer from "./mainSlice";
import { htmlSlice } from './mainSlice';

export const store = configureStore({
  reducer: {
    main: mainReducer,
    html: htmlSlice.reducer,
  },
});
